<template>
    <div class="warp-scroll" ref="myScrollbar">
        <div class="scroll">
            <slot></slot>
        </div>
        <div class="scroll-backtop" v-if="visible" @click="totop"><i class="el-icon-caret-top"></i></div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      visible: false
    }
  },
  mounted () {
    let _self = this
    let scrollbarEl = this.$refs.myScrollbar
    scrollbarEl.onscroll = function () {
      if (scrollbarEl.scrollTop > 200) {
        _self.visible = true
      } else {
        _self.visible = false
      }
    }
  },
  methods: {
    totop () {
      this.$refs.myScrollbar.scrollTop = 0
    }
  }
}
</script>

<style scoped>
  .warp-scroll{
    overflow-y: scroll;
    overflow-x: hidden;
    height:100%;
  }
  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  ::-webkit-scrollbar
  {
    width: 6px;
    height: 16px;
    /*background-color: rgba(0,0,0,0.3);*/
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track
  {
    /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);*/
    /*border-radius: 10px;*/
    background-color: #F7F8F9;
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb
  {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #DCDDDE;
  }
.scroll{
    width:100%;
    height:100%;
    background:#F7F8F9;
}
.el-scrollbar{
    height: 100%;
}
  .el-scrollbar /deep/ .el-scrollbar__wrap{
    overflow-x: hidden;
    background: #f7f8f9;
  }
  .el-scrollbar /deep/ .el-scrollbar__view{
      height: 100%;
  }
  .scroll-backtop{
    position: fixed;
    background-color: #fff;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: #409eff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    box-shadow: 0 0 6px rgb(0 0 0 / 12%);
    cursor: pointer;
    z-index: 5;
    right: 40px;
    bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/IrSlider.vue